export type SignupAttribution = {
  signupUtmSource?: string;
  signupUtmMedium?: string;
  signupUtmCampaign?: string;
  signupUtmContent?: string;
  signupReferrer?: string;
};

export type SignupAttributionEventProperties = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  referrer?: string;
};

const UTM_VALUE_MAX_LENGTH = 256;
const REFERRER_MAX_LENGTH = 2_048;

function normalizeOptionalString(
  value: unknown,
  maxLength: number,
): string | undefined {
  if (typeof value !== "string") {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed.slice(0, maxLength) : undefined;
}

export function normalizeSignupAttribution(
  input: unknown,
): SignupAttribution {
  if (typeof input !== "object" || input === null) {
    return {};
  }
  const values = input as Partial<
    Record<keyof SignupAttribution, unknown>
  >;
  const signupUtmSource = normalizeOptionalString(
    values.signupUtmSource,
    UTM_VALUE_MAX_LENGTH,
  );
  const signupUtmMedium = normalizeOptionalString(
    values.signupUtmMedium,
    UTM_VALUE_MAX_LENGTH,
  );
  const signupUtmCampaign = normalizeOptionalString(
    values.signupUtmCampaign,
    UTM_VALUE_MAX_LENGTH,
  );
  const signupUtmContent = normalizeOptionalString(
    values.signupUtmContent,
    UTM_VALUE_MAX_LENGTH,
  );
  const signupReferrer = normalizeOptionalString(
    values.signupReferrer,
    REFERRER_MAX_LENGTH,
  );

  return {
    ...(signupUtmSource !== undefined ? { signupUtmSource } : {}),
    ...(signupUtmMedium !== undefined ? { signupUtmMedium } : {}),
    ...(signupUtmCampaign !== undefined ? { signupUtmCampaign } : {}),
    ...(signupUtmContent !== undefined ? { signupUtmContent } : {}),
    ...(signupReferrer !== undefined ? { signupReferrer } : {}),
  };
}

export function toSignupAttributionEventProperties(
  attribution: SignupAttribution,
): SignupAttributionEventProperties {
  return {
    ...(attribution.signupUtmSource !== undefined
      ? { utm_source: attribution.signupUtmSource }
      : {}),
    ...(attribution.signupUtmMedium !== undefined
      ? { utm_medium: attribution.signupUtmMedium }
      : {}),
    ...(attribution.signupUtmCampaign !== undefined
      ? { utm_campaign: attribution.signupUtmCampaign }
      : {}),
    ...(attribution.signupUtmContent !== undefined
      ? { utm_content: attribution.signupUtmContent }
      : {}),
    ...(attribution.signupReferrer !== undefined
      ? { referrer: attribution.signupReferrer }
      : {}),
  };
}
